import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18;

import { BaseQuestionReportComponent } from '../../../bases';
import { useQuestionContext } from '../../../core';
import styled from '@xstyled/styled-components';
import { getSize, getColor } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// ─── Styled Components ────────────────────────────────────────────────────────
var StyledPanel = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  margin-top: ", ";\n"])), getSize('padding12'), getSize('padding16'));
var StyledSummaryBar = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: stretch;\n  border: 1px solid ", ";\n  border-radius: ", ";\n  overflow: hidden;\n"])), getColor('fillIntSubActive'), getSize('radiusSm'));
var StyledSummaryCell = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  padding: ", ";\n"])), getSize('gap4'), getSize('padding16'));
var StyledSummaryCellDivider = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 1px;\n  background: ", ";\n  flex-shrink: 0;\n"])), getColor('fillIntSubActive'));
var StyledSummaryCellLabel = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 600;\n  color: ", ";\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  line-height: 1rem;\n"])), getSize('typo12'), getColor('textIntSub'));
var StyledSummaryCellValue = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 700;\n  color: ", ";\n  line-height: 1.2;\n"])), getSize('typo24'), function (_ref) {
  var $isError = _ref.$isError;
  return $isError ? getColor('errorActive') : getColor('contentTitle');
});
var StyledSummaryCellDesc = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: ", ";\n  line-height: 1.4;\n  margin-top: 2px;\n"])), getSize('typo12'), getColor('textIntSub'));
var StyledDetailSection = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), getSize('gap8'));
var StyledDetailHeader = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 600;\n  color: ", ";\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n"])), getSize('typo12'), getColor('textIntSub'));
var StyledBlankList = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), getSize('gap8'));
var StyledBlankRow = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  padding: ", ";\n  border-radius: ", ";\n  background: ", ";\n  border: 1px solid\n    ", ";\n"])), getSize('padding16'), getSize('padding16'), getSize('radiusSm'), function (_ref2) {
  var $status = _ref2.$status;
  return $status === 'danger' ? getColor('errorBgActive') : $status === 'success' ? getColor('successBgActive') : getColor('fillBgSub');
}, function (_ref3) {
  var $status = _ref3.$status;
  return $status === 'danger' ? getColor('errorHighlighted') : $status === 'success' ? getColor('successHighlighted') : getColor('fillIntSubActive');
});
var StyledBlankBadge = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  width: 48px;\n  height: 48px;\n  border-radius: ", ";\n  background: ", ";\n  color: ", ";\n  font-size: ", ";\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  letter-spacing: 0.02em;\n"])), getSize('radiusSm'), function (_ref4) {
  var $status = _ref4.$status;
  return $status === 'danger' ? getColor('errorActive') : $status === 'success' ? getColor('successActive') : getColor('contentBody');
}, getColor('textIntWhite'), getSize('typo16'));
var StyledBlankCols = styled.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  flex: 1;\n  gap: ", ";\n"])), getSize('gap32'));
var StyledBlankCol = styled.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 120px;\n"])));
var StyledBlankColHeader = styled.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 600;\n  color: ", ";\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n"])), getSize('typo12'), getColor('textIntSub'));
var StyledBlankColValue = styled.div(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 600;\n  color: ", ";\n"])), getSize('typo14'), function (_ref5) {
  var $variant = _ref5.$variant;
  return $variant === 'error' ? getColor('errorActive') : $variant === 'success' ? getColor('successActive') : getColor('contentTitle');
});
var StyledBlankWarningBadge = styled.div(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  padding: 6px 14px;\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  font-size: ", ";\n  font-weight: 600;\n  color: ", ";\n  white-space: nowrap;\n  flex-shrink: 0;\n"])), getSize('gap4'), getColor('errorBgActive'), getColor('errorHighlighted'), getSize('radiusRounded'), getSize('typo12'), getColor('errorActive'));
var StyledBlankSuccessBadge = styled.div(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  padding: 6px 14px;\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  font-size: ", ";\n  font-weight: 600;\n  color: ", ";\n  white-space: nowrap;\n  flex-shrink: 0;\n"])), getSize('gap4'), getColor('successBgActive'), getColor('successHighlighted'), getSize('radiusRounded'), getSize('typo12'), getColor('successActive')); // ─── Stats Panel ──────────────────────────────────────────────────────────────

var getRowStatus = function getRowStatus(pct) {
  if (pct < 50) return 'danger';
  if (pct > 80) return 'success';
  return 'normal';
};

var MatchingStatsPanel = function MatchingStatsPanel(_ref6) {
  var _question$index;

  var totalCandidates = _ref6.totalCandidates,
      totalSubQuestions = _ref6.totalSubQuestions,
      accuracy = _ref6.accuracy,
      subQuestionReports = _ref6.subQuestionReports,
      labels = _ref6.labels;

  var _useQuestionContext = useQuestionContext(),
      question = _useQuestionContext.question;

  var startIndex = (_question$index = question === null || question === void 0 ? void 0 : question.index) !== null && _question$index !== void 0 ? _question$index : 1;
  return /*#__PURE__*/_jsxs(StyledPanel, {
    children: [/*#__PURE__*/_jsxs(StyledSummaryBar, {
      children: [/*#__PURE__*/_jsxs(StyledSummaryCell, {
        children: [/*#__PURE__*/_jsx(StyledSummaryCellLabel, {
          children: labels.totalCandidates
        }), /*#__PURE__*/_jsx(StyledSummaryCellValue, {
          children: totalCandidates
        }), /*#__PURE__*/_jsx(StyledSummaryCellDesc, {
          children: labels.studentsAttemptedDesc
        })]
      }), /*#__PURE__*/_jsx(StyledSummaryCellDivider, {}), /*#__PURE__*/_jsxs(StyledSummaryCell, {
        children: [/*#__PURE__*/_jsx(StyledSummaryCellLabel, {
          children: labels.overallAccuracy
        }), /*#__PURE__*/_jsxs(StyledSummaryCellValue, {
          $isError: accuracy === 0,
          children: [Math.round(accuracy), "%"]
        }), /*#__PURE__*/_jsx(StyledSummaryCellDesc, {
          children: labels.studentsAllPairsCorrectDesc
        })]
      }), /*#__PURE__*/_jsx(StyledSummaryCellDivider, {}), /*#__PURE__*/_jsxs(StyledSummaryCell, {
        children: [/*#__PURE__*/_jsx(StyledSummaryCellLabel, {
          children: labels.totalPairs
        }), /*#__PURE__*/_jsx(StyledSummaryCellValue, {
          children: totalSubQuestions
        }), /*#__PURE__*/_jsx(StyledSummaryCellDesc, {
          children: labels.matchingPairsDesc
        })]
      })]
    }), /*#__PURE__*/_jsxs(StyledDetailSection, {
      children: [/*#__PURE__*/_jsx(StyledDetailHeader, {
        children: labels.detailPerPair
      }), /*#__PURE__*/_jsx(StyledBlankList, {
        children: subQuestionReports === null || subQuestionReports === void 0 ? void 0 : subQuestionReports.map(function (report, i) {
          var status = getRowStatus(report.correctAnswerPercentage);
          var badgeNum = String(startIndex + i).padStart(2, '0');
          var total = report.totalCorrectAnswers + report.totalWrongAnswers;
          var wrongPct = 100 - report.correctAnswerPercentage;
          return /*#__PURE__*/_jsxs(StyledBlankRow, {
            $status: status,
            children: [/*#__PURE__*/_jsx(StyledBlankBadge, {
              $status: status,
              children: badgeNum
            }), /*#__PURE__*/_jsxs(StyledBlankCols, {
              children: [/*#__PURE__*/_jsxs(StyledBlankCol, {
                children: [/*#__PURE__*/_jsx(StyledBlankColHeader, {
                  children: labels.correctCount
                }), /*#__PURE__*/_jsxs(StyledBlankColValue, {
                  $variant: report.totalCorrectAnswers === 0 ? 'error' : 'success',
                  children: [report.totalCorrectAnswers, " / ", total, " ", labels.candidatesSuffix]
                })]
              }), /*#__PURE__*/_jsxs(StyledBlankCol, {
                children: [/*#__PURE__*/_jsx(StyledBlankColHeader, {
                  children: labels.accuracyPercent
                }), /*#__PURE__*/_jsxs(StyledBlankColValue, {
                  $variant: status === 'danger' ? 'error' : status === 'success' ? 'success' : 'default',
                  children: [report.correctAnswerPercentage, "%"]
                })]
              })]
            }), status === 'danger' && /*#__PURE__*/_jsx(StyledBlankWarningBadge, {
              children: labels.warningBadge(wrongPct)
            }), status === 'success' && /*#__PURE__*/_jsx(StyledBlankSuccessBadge, {
              children: labels.successBadge(report.correctAnswerPercentage)
            })]
          }, report.subQuestionId);
        })
      })]
    })]
  });
}; // ─── Main Component ───────────────────────────────────────────────────────────


export var MatchingReportComponent = function MatchingReportComponent(_ref7) {
  var states = _ref7.states,
      actions = _ref7.actions;
  var totalCandidates = states.totalCandidates,
      totalSubQuestions = states.totalSubQuestions,
      accuracy = states.accuracy,
      subQuestionReports = states.subQuestionReports,
      matchingLabel = states.matchingLabel;
  return /*#__PURE__*/_jsx(BaseQuestionReportComponent, {
    states: states,
    actions: actions,
    children: /*#__PURE__*/_jsx(MatchingStatsPanel, {
      totalCandidates: totalCandidates,
      totalSubQuestions: totalSubQuestions,
      accuracy: accuracy,
      subQuestionReports: subQuestionReports,
      labels: matchingLabel
    })
  });
};